export const EMPTY_COLLECTION: any[] = [];
export const EMPTY_RECORD: Record<any, any> = {};
